<template>
    <div v-if="!alreadyAccepted && !clickedAccept" id="cookie-box">
        <div class="body">
            <div style="display: block">{{$t('general.cookie_message','This website uses cookies to improve your experience. We\'ll assume you\'re ok with this, but you can opt-out if you wish.')}}</div>

            <div class="mt-3 d-flex align-items-center">
                <a class="btn btn-primary my-0 mr-4" @click="accept">{{ $t('general.accept') }}</a>
                <a class="btn btn-default mb-0 px-0" v-b-modal.privacy-modal>{{ $t('general.privacy_policy') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                clickedAccept: false
            }
        },
        computed: {
            alreadyAccepted() {
                return $cookies.isKey('cc');
            }
        },
        methods: {
            accept(event) {
                $cookies.set('cc', new Date().getTime(), 31536000);// 31536000 = 1 year
                this.clickedAccept = true;
            }
        }
    }
</script>
